import { createContext } from "react";
import type { ScheduleViewState } from "@/pages/human-resources/time-management/model/schedule-view/ScheduleViewState.ts";

export const ScheduleViewStateContext = createContext<
  ScheduleViewState | undefined
>(undefined);
